// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const VISUALIZATION_CATEGORY_VALUES = [
  'RECOMMENDED',
  'TABLE_AND_INDICATOR',
  'CHART',
  'MAP',
  'TEXT_AND_MEDIA',
  'OTHER',
] as const;

/** @see net/disy/cadenza/workbook/model/VisualizationCategory.java */
export type VisualizationCategory = (typeof VISUALIZATION_CATEGORY_VALUES)[number];

export const VisualizationCategory = {
  values: VISUALIZATION_CATEGORY_VALUES as readonly VisualizationCategory[],
} as const;

// </GENERATED-CODE>
